import React from 'react'
import PropTypes from 'prop-types'
import FormattedMessage from '../FormattedMessage/FormattedMessage'

import './Loader.scss'

const Loader = ({ noBorder, button, message }) => {
  const containerClasses = [
    'd-flex',
    'justify-content-center',
    'align-items-center',
    'input-loader',
  ]

  if (!noBorder) {
    if (button) {
      containerClasses.push('button-loader')
    } else {
      containerClasses.push('form-control')
      containerClasses.push('loader-noBorder')
    }
  }

  return (
    <div className={containerClasses.join(' ')} role="status" aria-live="polite" aria-busy="true">
      <div className="loader d-inline-block" />
      <span className="sr-only">
        {message || (
          <FormattedMessage id="global.label.loading" defaultMessage="Loading, please wait..." />
        )}
      </span>
    </div>
  )
}

Loader.defaultProps = {
  noBorder: false,
  button: false,
  message: '',
}

Loader.propTypes = {
  noBorder: PropTypes.bool,
  button: PropTypes.bool,
  message: PropTypes.string,
}

export default Loader
